import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../services/api/axios.config";
import { notify } from "../utils/methods/notification";

const initialState = {
  isLoading: false,
  error: false,
  errorMessage: "",
  errorType: "",
  inBoundForm: {},
};

// fetch the all primary diagnosis list
export const fetchPrimaryDiagnosis = createAsyncThunk(
  "bmr/fetchPrimaryDiagnosis",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/primary-diagnosis/list");
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// Add First Part of InBound Form
export const addInBoundForm = createAsyncThunk(
  "bmr/addInBoundForm",
  async ({ patient_id, hospital_id, id, data }, { rejectWithValue }) => {
    try {
      let url = `/inbond-patient/${patient_id}/${hospital_id}`
      if(id)
        url+='?id='+id;
      const response = await api.post(
        url,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "multipart/form-data",
          },
        }
      );
      notify.success(response.data.message);
      return response.data;
    } catch (error) {
      notify.error(error || error.message || error.response || error.response.data)
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// Submit Complete InBound Form
export const submitInBoundForm = createAsyncThunk(
  "bmr/addInBoundForm",
  async ({ inboundId,id, data, feasibility_assessments_id }, { rejectWithValue }) => {
    try {
       let url = `/inbond-patient/submit/${inboundId}/${feasibility_assessments_id}`
      if(id)
        url+='?id='+id;
      const response = await api.put(
       url,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "multipart/form-data",
          },
        }
      );
      if(data?.is_draft){
      notify.info('Draft saved successfully.');
      }else{
      notify.success(response.data.message);
      }
      return response.data;
    } catch (error) {
      notify.error(error.message || error.response || error.response.data);
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// Submit Complete InBound Form
export const receivedInBoundForm = createAsyncThunk(
  "bmr/receivedInBoundForm",
  async ({ inboundId, data, feasibility_assessments_id }, { rejectWithValue }) => {
    try {
      const response = await api.put(
        `/inbond-patient/received/${inboundId}/${feasibility_assessments_id}`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "multipart/form-data",
          },
        }
      );
     if(data?.is_draft){
       notify.info('Draft saved successfully.');
      }else{
       notify.success(response.data.message);
      }
      return response.data;
    } catch (error) {
      notify.error(error || error.message || error.response || error.response.data)
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);


// Api for approve Lsm
export const approveInBoundForm = createAsyncThunk(
  "bmr/approveInBoundForm",
  async ({ logisticsOperationsId, data = data }, { rejectWithValue }) => {
    try {
      const response = await api.patch(
        `/logistics/accept-lsm/${logisticsOperationsId}`,
        data
      );
      notify.success(response.data.message);
      return response.data;
    } catch (error) {
      notify.error(error || error.message || error.response || error.response.data)
      return rejectWithValue(
        error.response ? error.response.data : error.message || error
      );
    }
  }
);

// Api for reject Lsm
export const rejectLSM = createAsyncThunk(
  "bmr/rejectInBoundForm",
  async ({ logisticsOperationsId, data = {} }, { rejectWithValue }) => {
    try {
      const response = await api.patch(
        `logistics/reject-lsm/${logisticsOperationsId}`,
        data
      );
      notify.success(response.data.message);
      return response.data;
    } catch (error) {
       notify.error(error || error.message || error.response || error.response.data)
      return rejectWithValue(
        error.response ? error.response.data : error.message || error
      );
    }
  }
);

// updateInBoundForm
export const updateInBoundForm = createAsyncThunk(
  "bmr/updateInBoundForm",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await api.put(`/inbond-patient/all/${id}`, data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "multipart/form-data",
          },
        });
      notify.success(response.data.message);
      return response.data;
    } catch (error) {
       notify.error(error || error.message || error.response || error.response.data)
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// uploadFiles
export const uploadFiles = createAsyncThunk(
  "bmr/uploadFiles",
  async (args, { rejectWithValue }) => {
    try {
      const { data, id } = args;
      const response = await api.post(`/s3-upload/${id}?type=inbound`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "multipart/form-data",
        },
      });
      notify.success(response.data.message);
      return response.data;
    } catch (error) {
     notify.error(error || error?.message || error?.response || error?.response?.data)
      return rejectWithValue(
        error?.response ? error?.response?.data : error?.message
      );
    }
  }
);

// fetch the details for in bound form
export const fetchDetailsInBound = createAsyncThunk(
  "bmr/fetchDetailsInBound",
  async ({inBoundId, feasibility_assessments}, { rejectWithValue }) => {
    try {
      const response = await api.get(`inbond-patient/${inBoundId}/${feasibility_assessments}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// deleteFiles
export const deleteFile = createAsyncThunk(
  "bmr/deleteFile",
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.delete(`/s3-delete/${id}`);
      notify.success(response.data.message);
      return response.data;
    } catch (error) {
      notify.error(error || error.message || error.response || error.response.data)
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

const bmrInBoundSlice = createSlice({
  name: "bmrInBound",
  initialState,
  extraReducers: (builder) => {
    /// handle fetch all primary diagnosis list
    builder
      .addCase(fetchPrimaryDiagnosis.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchPrimaryDiagnosis.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(fetchPrimaryDiagnosis.rejected, (state) => {
        state.isLoading = false;
      });
    /// handle fetch all primary diagnosis list
    builder
      .addCase(addInBoundForm.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addInBoundForm.fulfilled, (state, action) => {
        state.isLoading = false;
        state.errorMessage = action?.payload?.message;
        state.errorType = "success";
        state.error = true;
      })
      .addCase(addInBoundForm.rejected, (state, action) => {
        state.isLoading = false;
        state.errorMessage = action?.payload?.message ?? '';
        state.errorType = "error";
        state.error = true;
      });

    builder
      .addCase(receivedInBoundForm.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(receivedInBoundForm.fulfilled, (state, action) => {
        state.isLoading = false;
        state.errorMessage = action?.payload?.message ?? '';
        state.errorType = "success";
        state.error = true;
      })
      .addCase(receivedInBoundForm.rejected, (state, action) => {
        state.isLoading = false;
        state.errorMessage = action?.payload?.message ?? '';
        state.errorType = "error";
        state.error = true;
      });
    /////updateInBoundForm
    builder
      .addCase(updateInBoundForm.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateInBoundForm.fulfilled, (state, action) => {
        state.isLoading = false;
        state.errorMessage = action?.payload?.message ?? '';
        state.errorType = "success";
        state.error = true;
      })
      .addCase(updateInBoundForm.rejected, (state, action) => {
        state.isLoading = false;
        state.errorMessage = action?.payload?.message ?? '';
        state.errorType = "error";
        state.error = true;
      });
    /// handle fetch all primary diagnosis list

    builder
      .addCase(fetchDetailsInBound.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchDetailsInBound.fulfilled, (state, action) => {
        state.isLoading = false;
        state.inBoundForm = action.payload.data;
      })
      .addCase(fetchDetailsInBound.rejected, (state) => {
        state.isLoading = false;
        state.inBoundForm = {};
      });
    /// handle uploadFiles

    builder
      .addCase(uploadFiles.pending, (state) => {
        state.isLoading = false;
      })
      .addCase(uploadFiles.fulfilled, (state, action) => {
        state.isLoading = false;
        state.errorMessage = action.payload?.message ?? "";
        state.errorType = "success";
        state.error = true;
      })
      .addCase(uploadFiles.rejected, (state, action) => {
        state.isLoading = false;
        state.errorMessage = action.payload?.message ?? "File upload failed";
        state.errorType = "error";
        state.error = true;
      });
    /// handle deleteFilesd

    builder
      .addCase(deleteFile.pending, (state) => {
        state.isLoading = false;
      })
      .addCase(deleteFile.fulfilled, (state, action) => {
        state.isLoading = false;
        state.errorMessage = action?.payload?.message;
        state.errorType = "success";
        state.error = true;
      })
      .addCase(deleteFile.rejected, (state, action) => {
        state.isLoading = false;
        state.errorMessage = action.payload?.message ?? "File deletion failed";
        state.errorType = "error";
        state.error = true;
      });
    }
});

export const selectbmrInBoundLoading = (state) => state.bmrInBound.isLoading;
export const selectbmrInBoundDetails = (state) => state.bmrInBound.inBoundForm;

export default bmrInBoundSlice.reducer;
